import { useCallback } from "react";
import { useParams } from "react-router-dom";

import { buildMemberPath, buildMemberSettingsPath } from "../path";

export function useMemberPath() {
  const { orgCode = "" } = useParams<{ orgCode: string }>();

  const path = useCallback(
    (subpath: string) => `${buildMemberPath(orgCode)}/${subpath}`,
    [orgCode],
  );

  const settingsPath = useCallback(
    (subpath: string) => `${buildMemberSettingsPath(orgCode)}/${subpath}`,
    [orgCode],
  );

  return { path, settingsPath, orgCode };
}
